import { Button, soundManager, SoundType } from '@slot-nx/core'
import { Container } from '@pixi/react'
import { Image } from '@slot-nx/core'
import { useGameStore } from '../domain/game/store/GameStore'
import { useEffect, useState } from 'react'
import { usePopupStore } from '../domain/popup/popupStore'
import { BetOptionType } from '../domain/placeOrder/utils/stakeUtils'
import { SelectContent } from './SelectContent'
import { ConfirmContent } from './ConfirmContent'
import { gameConfig } from '../config'
import { GrayBackground } from './GrayBackground'
import { GameSoundType } from '../domain/sound/GameSoundType'

interface BuyBonusPopupProps { x: number, y: number }

export const BuyBonusPopup = (props: BuyBonusPopupProps) => {
  const isOpenBonusGamePopup = usePopupStore(x => x.isOpenBonusGamePopup)
  const [showConfirmContent, setShowConfirmContent] = useState(false)
  const popupBg = showConfirmContent ? 'image_buyBonusFrame02' : 'image_buyBonusFrame01'

  useEffect(() => {
    if (isOpenBonusGamePopup) {
      setShowConfirmContent(false)
      soundManager.play(GameSoundType.ThreeComboOlympus_BuyBonus)
    }
  }, [isOpenBonusGamePopup])

  return isOpenBonusGamePopup
    ? (
        <GrayBackground name="BuyFreeSpinPopup" width={gameConfig.resolution.width} height={gameConfig.resolution.height}>
          <Container x={props.x} y={props.y}>
            <Image name="bg_popupShadow" image="bg_popupShadow" x={0} y={0} anchor={[0.5, 0.5]} />
            <Image name="font_buyBonus" image="font_buyBonus" x={0} y={-450} anchor={0.5} />
            <Image name="image_buyBonusFrame01" image={popupBg} x={0} y={0} anchor={0.5} />
            <Button
              name="close button"
              x={400}
              y={-425}
              enabled
              visible={!showConfirmContent}
              width={126}
              height={125}
              defaultView="btn_close_normal"
              hoverView="btn_close_hover"
              disabledView="btn_close_disable"
              pressedView="btn_close_click"
              onPressing={() => soundManager.play(SoundType.buttonClose)}
              onPress={() => {
                usePopupStore.setState({ isOpenBonusGamePopup: false })
                useGameStore.setState({ betOptionType: BetOptionType.MainGame })
              }}
            />
            {
              !showConfirmContent
                ? <SelectContent setShowConfirmContent={setShowConfirmContent} />
                : <ConfirmContent setShowConfirmContent={setShowConfirmContent} />
            }
          </Container>
        </GrayBackground>
      )
    : null
}
